import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=6dd3afc1&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=6dd3afc1&prod&scoped=true&lang=css"
import style1 from "./feedback.vue?vue&type=style&index=1&id=6dd3afc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3afc1",
  null
  
)

export default component.exports